import styled from "styled-components/macro";

const PageContent = styled.main`
    min-height: 60vh;
    margin-left: auto;
    margin-right: auto;
    padding: 4.5rem var(--page-margin-horizontal);

    >* + * {
        margin-top: 3rem;
    }

    & * {
        /* Firefox */
        scrollbar-color: var(--color-surface-dark1) var(--color-on-surface-lighter);
        scrollbar-width: thin;

        /* Chrome, Microsoft Edge, Safari ... */
        ::-webkit-scrollbar {
            width: .4rem;
            background-color: var(--color-on-surface-lighter);
        }

        ::-webkit-scrollbar-thumb {
            background-color: var(--color-surface-dark1);
        }

        ::-webkit-scrollbar-track {
            background-color: var(--color-on-surface-lighter);
            border-left: solid .1rem white;
            border-right: solid .1rem white;
        }
    }
`;

export default PageContent;
